export default "__VITE_ASSET__C5JEO$5k__"